import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	restrictedContent: {
		id: 'custom-sites-extensions.link-cards-content.card-components.error-states.restricted-content.header',
		defaultMessage: 'Restricted content',
		description:
			'Heading message shown when a URL we are trying to render as a smart card is restricted from user access',
	},
	restrictedContentDescription: {
		id: 'custom-sites-extensions.link-cards-content.card-components.error-states.restricted-content.description',
		defaultMessage: 'You’ll need to request access or try another account to view this preview',
		description:
			'Describes possible action when a URL we are trying to render as a smart card is restricted from user access',
	},
	restrictedContentButtonLabel: {
		id: 'custom-sites-extensions.link-cards-content.card-components.error-states.restricted-content.button.label',
		defaultMessage: 'Request access',
		description:
			'Label for button that allows user to access restricted content page to request access',
	},
});
